import { render, staticRenderFns } from "./BoardSummary.vue?vue&type=template&id=1c0c2d18"
import script from "./BoardSummary.ts?vue&type=script&lang=ts&external"
export * from "./BoardSummary.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports